import { render, staticRenderFns } from "./TableColumnGuide.vue?vue&type=template&id=79798505&"
import script from "./TableColumnGuide.vue?vue&type=script&lang=ts&"
export * from "./TableColumnGuide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports